
<div class='options' [class.selected]='isSelected' [class.emoji]="emoji" [class.horizontal]="horizontal" [class.vertical]="vertical" [ngClass]="className" role='group'>
    <ng-container *ngFor='let option of params.options'>
        <ng-container *ngIf="emoji">
            <button type="button" (click)='onSubmit(option)'
                    (animationend)='content.reportUpdated(null)'
                    [disabled]='!enabled'
                    [class]='option.class || ""'
                    [class.active]='active'
                    [class.selected]='isSelected && equalsSelected(option.value)'
                    [class.echo]='option.echo'
                    [class.not-selected]='isSelected && !equalsSelected(option.value)'>
                <div class="icon" [class.selected]='isSelected && equalsSelected(option.value)'>
                    <img [src]="option.image" [attr.alt]="option.value" />
                    <img [src]="option.activeImage" [attr.alt]="option.value" />
                </div>
                <span [innerHtml]='option.display'></span>
            </button>
        </ng-container>
        <ng-container *ngIf="!emoji">
            <button type="button" (click)='onSubmit(option)'
                    (animationend)='content.reportUpdated(null)'
                    [disabled]='!enabled'
                    [class]='option.class || ""'
                    [class.active]='active'
                    [class.selected]='isSelected && equalsSelected(option.value)'
                    [class.echo]='option.echo'
                    [class.not-selected]='isSelected && !equalsSelected(option.value)'>
                <span [innerHtml]='option.display'></span>
            </button>
        </ng-container>
    </ng-container>
    <a class='fixme' *ngIf='params.fixme && echoSelected' (click)='params.fixme()' [innerHTML]='params.fixmeMessage'></a>
</div>
<chatbot-message-back *ngIf="content.backButton && isSelected" [content]='content' [params]='params'></chatbot-message-back>
